import { render, staticRenderFns } from "./DefaultCallCenter.vue?vue&type=template&id=1258cd14&scoped=true&"
import script from "./DefaultCallCenter.vue?vue&type=script&lang=js&"
export * from "./DefaultCallCenter.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCallCenter.vue?vue&type=style&index=0&id=1258cd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258cd14",
  null
  
)

export default component.exports